import axios from 'axios';
import _ from 'lodash';
import { config } from 'constants/config';

export const settings = {
  baseURL: `${config.baseUrl}`,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: 'application/json',
    'Content-Type': 'application/json;charset',
  },
};

const instance = axios.create(settings);

export default {
  get(url, request = {}, baseURL = null) {
    instance.defaults.baseURL = baseURL || settings.baseURL;

    // Keep headers if provided, otherwise use default headers
    const config = request || {};
    if (!config.headers) {
      config.headers = instance.defaults.headers; 
    }

    return instance
      .get(url, config)
      .then(response => Promise.resolve(response))
      .catch(error => {
        if (error.statusCode === 91) {
          return;
        }
        return Promise.reject(error.response?.data || error);
      });
  },
  post(url, request, baseURL = null) {
    instance.defaults.baseURL = baseURL || settings.baseURL;
    return instance
      .post(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
  put(url, request, baseURL = null) {
    instance.defaults.baseURL = baseURL || settings.baseURL;
    return instance
      .put(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
  patch(url, request, baseURL = null) {
    instance.defaults.baseURL = baseURL || settings.baseURL;
    return instance
      .patch(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
  delete(url, request, baseURL = null) {
    instance.defaults.baseURL = baseURL || settings.baseURL;
    return instance
      .delete(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
};
